'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$0024 from "./presto.-Login-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445 from "./presto.-Presto-Router$$anon$45.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$44() {
  this.biK = null;
  this.biC = null;
  this.biD = false;
  this.biL = null;
  this.biM = false;
  this.biP = null;
  this.biI = null;
  this.biJ = false;
  this.biE = null;
  this.biF = false;
  this.biG = null;
  this.biH = false;
  this.biN = false;
  this.biO = false;
  this.biK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.biP = "LoginPage";
}
export { $c_Lpresto_PrestoRouter$$anon$44 as $c_Lpresto_PrestoRouter$$anon$44 };
$p = $c_Lpresto_PrestoRouter$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$44;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$44() {
}
export { $h_Lpresto_PrestoRouter$$anon$44 as $h_Lpresto_PrestoRouter$$anon$44 };
$h_Lpresto_PrestoRouter$$anon$44.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.biK;
});
$p.L = (function() {
  if ((!this.biD)) {
    this.biC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biD = true;
  }
  return this.biC;
});
$p.O = (function() {
  if ((!this.biM)) {
    this.biL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.biM = true;
  }
  return this.biL;
});
$p.E = (function() {
  return this.biP;
});
$p.t = (function() {
  if ((!this.biJ)) {
    this.biI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biJ = true;
  }
  return this.biI;
});
$p.M = (function() {
  if ((!this.biF)) {
    this.biE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biF = true;
  }
  return this.biE;
});
$p.Q = (function() {
  if ((!this.biH)) {
    this.biG = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445.$c_Lpresto_PrestoRouter$$anon$45();
    this.biH = true;
  }
  return this.biG;
});
$p.w = (function() {
  if ((!this.biO)) {
    this.biN = false;
    this.biO = true;
  }
  return this.biN;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee370) => ((p) => \u03b4scrutinee370))($j_presto$002e$002dLogin$002dPage$0024.$m_Lpresto_LoginPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$44, "presto.PrestoRouter$$anon$44", ({
  Ob: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$44 as $d_Lpresto_PrestoRouter$$anon$44 };
//# sourceMappingURL=presto.-Presto-Router$$anon$44.js.map
